export const idx_data_ball_manufacturer = [];

idx_data_ball_manufacturer.push({
  manufacturer: "",
});

idx_data_ball_manufacturer.push({
  manufacturer: "900 Global",
});

idx_data_ball_manufacturer.push({
  manufacturer: "AMF",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Brunswick",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Columbia 300",
});

idx_data_ball_manufacturer.push({
  manufacturer: "DV8",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Ebonite",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Hammer",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Motiv",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Radical",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Roto Grip",
});

// idx_data_ball_manufacturer.push({
//   manufacturer: 'Seismic',
// });

idx_data_ball_manufacturer.push({
  manufacturer: "Storm",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Track",
});

idx_data_ball_manufacturer.push({
  manufacturer: "Other",
});

// idx_data_ball_manufacturer.push({
//   manufacturer: 'Big Bowling',
// });

idx_data_ball_manufacturer.push({
  manufacturer: "Swag",
});
